import { render, staticRenderFns } from "./AllPublicNotes.vue?vue&type=template&id=31948621&scoped=true&"
import script from "./AllPublicNotes.vue?vue&type=script&lang=js&"
export * from "./AllPublicNotes.vue?vue&type=script&lang=js&"
import style0 from "./AllPublicNotes.vue?vue&type=style&index=0&id=31948621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31948621",
  null
  
)

export default component.exports